var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoALetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 6,
    fill: "white",
    stroke: "#4E5978",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93 17L10.822 7.2H12.922L16.772 17H14.238L13.58 15.222H10.066L9.408 17H6.93ZM11.186 12.198L10.752 13.36H12.894L12.446 12.17C12.3433 11.8713 12.236 11.568 12.124 11.26C12.0213 10.952 11.9233 10.6393 11.83 10.322C11.7367 10.63 11.6387 10.9333 11.536 11.232C11.4333 11.5307 11.3167 11.8527 11.186 12.198Z",
    fill: "#4E5978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoALetter);
export default __webpack_public_path__ + "static/media/ico-A-letter.5e600dfe.svg";
export { ForwardRef as ReactComponent };